import React, { useState, useEffect } from 'react'
// import styles from '@/styles/Home.module.scss'
import styles from '@/styles/Notice.module.scss'
import Layout from '@/components/Layout'
import { time } from '@/lib/util'
import { RootState } from '@/app/store'
import { useSelector } from 'react-redux'

const Period = () => {
  const [PeriodPagesState, setPeriodPagesState] = useState(undefined)
  const datadataCampaign = useSelector(
    (state: RootState) => state.apiAsync.campaign
  )

  const nowDate = () => {
    const date = new Date()
    return (
      date.getFullYear() +
      '年' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '月' +
      ('0' + date.getDate()).slice(-2) +
      '日'
    )
  }

  useEffect(() => {
    if (datadataCampaign.campaignEndAt !== '') {
      setPeriodPagesState(datadataCampaign)
    }
  }, [datadataCampaign])

  useEffect(() => {
    if (PeriodPagesState !== undefined) {
      if (datadataCampaign.period) {
        location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/auth/signin`
        return
      }
    }
  }, [PeriodPagesState])

  return (
    <Layout title="キャンペーン期間外">
      <div className="c-contents bg-white px-4 pt-4 pb-6">
        {datadataCampaign.outOfTermMessage !== undefined ? (
          <section
            className={`${styles.c_rule} ${styles.c_notice} rounded-[4px] border-[2px] border-[#ffc600] to-white py-4 px-4`}
            dangerouslySetInnerHTML={{
              __html: datadataCampaign.outOfTermMessage,
            }}
          />
        ) : (
          ''
        )}
      </div>

      {/* <div className={styles.c_period_wrap}>
        {datadataCampaign.period ? (
          <p className={`text-sm ${styles.c_period}`}>
            開催期間: {`${time(datadataCampaign.campaignStartAt)}`} ~{' '}
            {`${time(datadataCampaign.campaignEndAt)}`}
          </p>
        ) : (
          <>
            {`${time(datadataCampaign.campaignStartAt)}` > nowDate() ? (
              <p className={`text-sm ${styles.c_period}`}>
                {datadataCampaign.name}はイベント期間前です。
                <span className="block">
                  開催期間: {`${time(datadataCampaign.campaignStartAt)}`} ~{' '}
                  {`${time(datadataCampaign.campaignEndAt)}`}
                </span>
              </p>
            ) : (
              ''
            )}
            {`${time(datadataCampaign.campaignEndAt)}` < nowDate() ? (
              <>
                <p className={`text-sm ${styles.c_period}`}>
                  {datadataCampaign.name}のイベントは終了しました。
                </p>
              </>
            ) : (
              ''
            )}
          </>
        )}
      </div> */}
    </Layout>
  )
}

export default Period
